import { defineComponent as _defineComponent } from 'vue'
import useCommonMixin from '@/composables/useCommonMixin'
  import OtherAcademiesSignup from '@/components/signup/OtherAcademiesSignup.vue'
  import AcademySignup from '@/components/signup/AcademySignup.vue'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CustomRegistration',
  setup(__props) {

  const { isSachkundeCompany } = useCommonMixin()

return { __sfc: true,isSachkundeCompany, useCommonMixin, OtherAcademiesSignup, AcademySignup }
}

})